<h2 [innerHTML]="'hotels.title' | translate"></h2>
<p class="large" [innerHTML]="'hotels.intro' | translate"></p>
<div class="hotels-wrapper">
    <ng-container *ngIf="hotels && hotels.length > 0">
        <div class="hotel" *ngFor="let hotel of hotels">
            <div class="item">
                <div>
                    <a class="underlined-link" href="{{ hotel.url }}" target="_blank">{{ hotel.name }}</a>
                </div>
                <div>
                    <span>{{ hotel.street }}</span>
                </div>
                <div>
                    <span>{{ hotel.zip }} {{ hotel.city }}</span>
                </div>
                <div>
                    <span [innerHTML]="'hotels.tel' | translate">Tel: </span>
                    <span>
                        +<span [innerHTML]="hotel.phoneCountry.replaceAll('00', '').replaceAll('+', '')"></span>
                        <span>(<span [innerHTML]="hotel.phoneCity.replaceAll('0', '').replaceAll('+', '')"></span>)</span>

                        {{ hotel.phoneNumber }}
                    </span>
                </div>
                <div>
                    <span [innerHTML]="'hotels.email' | translate">Email: </span> <a class="underlined-link" href="mailto:{{ hotel.email }}">{{ hotel.email }}</a>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!hotels || (hotels && hotels.length <= 0)">
        <strong [innerHTML]="'hotels.noHotels' | translate"></strong>
    </ng-container>
</div>
